'use strict';

angular.module('TurneroApp').component('coHeaderciudadano', {
    bindings: {
        usuario: '<'
    },
    controller: [
        '$window',
        'seguridadService',
        'TurneroAppConstant',
        '$rootScope',
        'generalService',
        'miDoctaModoService',
        function ($window, seguridadService, TurneroAppConstant, $rootScope, generalService, miDoctaModoService) {
            var ctrl = this;
            ctrl.constantes = TurneroAppConstant;
            ctrl.modoMiDocta = miDoctaModoService.estaActivo();

            ctrl.home = function () {
                $rootScope.$broadcast('esHome', true);
                $rootScope.$broadcast('esCalendario', false);
                $rootScope.$broadcast('esTasaRetributiva', false);
                // Mantenemos el modo iframe Mi Docta al volver al home (preservar query).
                $window.location.href = miDoctaModoService.urlInternaConModo('./turnos');
            };

            ctrl.logOut = function () {
                if (miDoctaModoService.estaActivo()) {
                    // En el iframe Mi Docta no se cierra sesión desde Turnero:
                    // el ciclo de vida de la sesión lo controla Mi Docta.
                    swal({
                        title: 'Volvé a Mi Docta',
                        html: 'Para cerrar tu sesión, hacelo desde el portal de Mi Docta.',
                        type: 'info',
                        confirmButtonColor: '#004b81',
                        confirmButtonText: 'Aceptar'
                    });
                    return;
                }
                seguridadService.logOut();
                seguridadService.removeCookies();
                $window.location.href = $rootScope.urlHostServer + 'logout';
            };

            ctrl.ChangeUsuario = function () {
                if (miDoctaModoService.estaActivo()) {
                    // Cambiar de representado redirige a CiDi: bloqueado en iframe.
                    swal({
                        title: 'Acción no disponible',
                        html: 'Para cambiar de usuario representado, hacelo desde Mi Docta y volvé a ingresar.',
                        type: 'info',
                        confirmButtonColor: '#004b81',
                        confirmButtonText: 'Aceptar'
                    });
                    return;
                }
                console.log('URL desde el FRONT: ' + $rootScope.urlHostServer + 'Logout/CambiarUsuarioRepresentado');
                console.log('Constante VeDi Relacion: ' + ctrl.constantes.vedi.ciDiUrlRelacion + ctrl.constantes.vedi.ciDiIdAplicacion);

                seguridadService.logOut();
                generalService.Cambiar_Usuario_Representado().$promise.then(function (result) {
                    $window.location.href = result.Data;
                }).catch(function (req) {
                    utilsService.errores(req);
                });                                
            };

            ctrl.logOutSinCerrarSesionCiDi = function () {
                if (miDoctaModoService.estaActivo()) {
                    swal({
                        title: 'Volvé a Mi Docta',
                        html: 'Para cerrar tu sesión, hacelo desde el portal de Mi Docta.',
                        type: 'info',
                        confirmButtonColor: '#004b81',
                        confirmButtonText: 'Aceptar'
                    });
                    return;
                }
                console.log('URL desde el FRONT: ' + $rootScope.urlHostServer + 'Logout/LogoutSinCerrarSesionCiDi');
                console.log('Constante VeDi: ' + ctrl.constantes.vedi.url);

                seguridadService.logOut();
                generalService.Limpiar_Datos_Sin_Cerrar_Sesion_CiDi().$promise.then(function (result) {
                    $window.location.href = result.Data;
                }).catch(function (req) {
                    utilsService.errores(req);
                });               
            };
        }],
    template: require('./header_Ciudadano.html')
});



// WEBPACK FOOTER //
// ./app/shared/header/headerCiudadanoComponent.js